import * as React from 'react';

export const CheckmarkIcon: React.FC<{}> = () => (
    <svg className="dr-ui-checkmark-icon" viewBox="0 -225.36 225.36 225.36" xmlns="http://www.w3.org/2000/svg">
        <g id="Layer 1" transform="scale(1 -1)">
            <path
                d={`M 3.435,91.955 C -7.903,152.158 31.752,210.227 91.955,221.565 C 152.158,232.903 210.227,193.248
                221.565,133.045 C 232.903,72.842 193.248,14.773 133.045,3.435 C 72.842,-7.903 14.773,31.752 3.435,91.955
                Z M 99.504,63.816 L 179.193,140.804 L 156.231,161.514 L 98.153,103.886 L 70.239,130.899 L 50.88,109.288
                L 99.504,63.816 Z`}
                className="svg-elt-fill"
                strokeLinejoin="miter"
                stroke="none"
                markerStart="none"
                markerEnd="none"
            />
        </g>
    </svg>
);
